import { Request } from '../../httpClient/serverApi/requests/Request';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export interface IGetTabcldNotificationsResult extends IResult {
  notificationList: any[];
}

export class GetTabcldNotificationsRequest
    extends Request<{}, IGetTabcldNotificationsResult> {

  constructor(scope: string, location?: string) {
    super('getScheduledNotifications', {scope: scope, location: location}, {});
  }

}
